var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 2.29473C6.19233 2.29473 2.29485 6.19221 2.29485 11C2.29485 15.8078 6.19233 19.7053 11.0001 19.7053C15.8079 19.7053 19.7054 15.8078 19.7054 11C19.7054 6.19221 15.8079 2.29473 11.0001 2.29473ZM1.37207 11C1.37207 5.68258 5.6827 1.37195 11.0001 1.37195C16.3176 1.37195 20.6282 5.68258 20.6282 11C20.6282 16.3174 16.3176 20.6281 11.0001 20.6281C5.6827 20.6281 1.37207 16.3174 1.37207 11Z",
    fill: "#B41730"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6499 15.4H10.3444V9.56884H11.6499V15.4ZM10.2666 8.02405C10.2666 7.80261 10.3296 7.63214 10.4555 7.51263C10.5851 7.39313 10.7685 7.33337 11.0055 7.33337C11.2351 7.33337 11.4129 7.39313 11.5388 7.51263C11.6685 7.63214 11.7333 7.80261 11.7333 8.02405C11.7333 8.23494 11.6685 8.4019 11.5388 8.52492C11.4129 8.64443 11.2351 8.70418 11.0055 8.70418C10.7685 8.70418 10.5851 8.64443 10.4555 8.52492C10.3296 8.4019 10.2666 8.23494 10.2666 8.02405Z",
    fill: "#B41730"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.783a197b.svg";
export { ForwardRef as ReactComponent };